import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Message } from 'element-ui'

// 配置Element UI默认组件大小
Vue.use(Element, {
  size: 'mini', // 设置默认组件大小为最小
  zIndex: 3000
})

Vue.prototype.$message = Message
